import React from 'react'
import { SVGIcon } from '~/utils/types'

export const TwitterX = (props: SVGIcon) => (
  <svg
    width="52"
    height="52"
    viewBox="0 0 52 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M28.0955 24.3165L36.2864 15H34.3456L27.2303 23.0877L21.5514 15H15L23.5895 27.2311L15 37H16.9407L24.4501 28.4571L30.4486 37H37L28.0955 24.3165ZM25.4365 27.3385L24.5649 26.1198L17.6406 16.4316H20.6219L26.2117 24.2532L27.0797 25.4719L34.3447 35.6381H31.3634L25.4365 27.3385Z"
      fill="currentColor"
    />
  </svg>
)
